import firebase from "firebase";
import {MaintenanceRequestStatus} from "@/enums/MaintenanceRequestStatus";

export default {
  name: "maintenanceRequestCancelDlg",
  data() {
    return {
      dialog: false,
      requestId: null,
      comment: "",
      loading: false
    }
  },
  methods: {
    open(requestId) {
      this.dialog = true;
      this.requestId = requestId;
    },
    close() {
      this.dialog = false;
      this.requestId = null;
      this.comment = "";
    },
    async submit() {
      this.loading = true;

      await firebase
        .firestore()
        .collection("maintenanceRequests")
        .doc(this.requestId)
        .update({
          status: MaintenanceRequestStatus.Cancelled,
          cancellationComment: this.comment,
          cancelledDateTime: firebase.firestore.Timestamp.fromDate(new Date())
        }).then(async () => {
          await this.$store.dispatch('getMaintenanceRequest', this.$route.params.id);

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceView.RequestHasBeenSuccessfullyCanceled")
          })
          this.loading = false;
          this.close();
        })
    }
  }
}